import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { AuthService } from './auth.service';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response) {
        if (event.status === 401) {
          // Handle unauthorized requests
          // Later, we might want to try and refresh the token first
          const router = inject(Router);
          const auth = inject(AuthService);

          auth.signOut();
          router.navigate(['/auth/sign-in']);
        }
      }
    })
  );
};
